import React from 'react';
import { createRoot } from "react-dom/client";
import SearchResultContainerApp from "./SearchResultContainerApp";

const container = document.getElementById('js-search-result-container')!;

if (container){
    const root = createRoot(container);
    root.render(<SearchResultContainerApp />);
}
